import { useGetQuickAddDealsQuery } from "@/api/reduxToolkit/contentfulData";

export const useGetQuickAddDeals = (): Record<string, boolean> => {
  const { data: quickAddDeals, isLoading } = useGetQuickAddDealsQuery(undefined);

  if (isLoading || !quickAddDeals) {
    return {};
  }

  return quickAddDeals;
}